import type { GameDefinition } from "../game";
import { PgxHex } from "./environment";
import { HexRenderer } from "./renderer";
import type { HexState } from "./types";

const size = 4;
const environment = new PgxHex(size);

export const hex4Definition: GameDefinition<HexState> = {
  gameId: "hex",
  gameName: "Hex",
  variantId: "hexnoswap_4x4",
  variantName: "No-swap 4×4",
  board: { width: size, height: size },
  observationShape: [size, size, 4],
  actionCount: size * size,
  defaultSimulations: 32,
  defaultHumanPlayer: 1,
  modelIds: ["katago-hex4-v2"],
  playerNames: ["Red · north–south", "Blue · west–east"],
  controls: {},
  createEnvironment: () => environment,
  createRenderer: () => new HexRenderer(),
  createInferenceInput: (state) => ({
    observation: environment.observe(state),
    legalActionMask: environment.legalActionMask(state),
  }),
  statusText: (state) => state.terminated
    ? `${state.winner === 0 ? "Red" : "Blue"} connects and wins`
    : `${state.currentPlayer === 0 ? "Red" : "Blue"} to move`,
  moveHistory: (state) => state.moves.map((move) => move.label),
};

export { PgxHex } from "./environment";
export { HexRenderer } from "./renderer";
export type { HexMove, HexState } from "./types";
